import { applySnapshot, types, flow } from "mobx-state-tree";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import systemHelperAPI from "../systemhelper/SystemHelperService";
import { ErrorModel } from "../../components/common/error";

export const RegulationModel = types
  .model("RegulationModel", {
    lovKey: customtypes.optional(types.number, 0),
    regCode: types.maybeNull(types.string),
    regName: types.maybeNull(types.string),
    regDetail: types.maybeNull(types.string),
    regHtml: types.maybeNull(types.string),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    resetAll: () => {
      applySnapshot(self, {});
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    updatePDMORegulations: flow(function* () {
      try {
        self.loading = true;
        yield systemHelperAPI.updatePDMORegulations(self);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
  }));
export type IRegulationModel = typeof RegulationModel.Type;

export const RegulationListModel = types
  .model("RegulationListModel", {
    list: customtypes.optional(types.array(RegulationModel), []),
    itemEdit: customtypes.optional(RegulationModel, {}),
    error: types.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    resetAll: () => {
      self = []
    },
    getPDMORegulations: flow(function* () {
      try {
        self.loading = true;
        const result = yield systemHelperAPI.getPDMORegulations();
        self.list = result.data
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        throw e;
      } finally {
        self.loading = false;
      }
    }),

  }));
export type IRegulationListModel = typeof RegulationListModel.Type;
